module.exports = __webpack_public_path__ + "img/service-two.cf0ffb12.png";